// 브라우저 알림 — 앱이 열려 있거나 백그라운드 탭일 때 동작.
// (앱 완전 종료 상태의 푸시는 web-push/VAPID + 백엔드가 별도로 필요 — 후속 단계)

export function notifySupported(): boolean {
  return typeof window !== "undefined" && "Notification" in window;
}

export async function ensureNotifyPermission(): Promise<boolean> {
  if (!notifySupported()) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  try {
    return (await Notification.requestPermission()) === "granted";
  } catch {
    return false;
  }
}

export function notify(title: string, body?: string) {
  if (!notifySupported() || Notification.permission !== "granted") return;
  try {
    new Notification(title, { body, icon: "/icon-192.png", badge: "/favicon-32.png" });
  } catch {
    /* 일부 브라우저는 SW 컨텍스트에서만 허용 — 조용히 무시 */
  }
}
